class Queue {
  private queue: Function[]

  constructor() {
    this.queue = []
  }

  get size(): number {
    return this.queue.length
  }

  enqueue(run: Function) {
    this.queue.push(run)
  }

  dequeue(): Function {
    return this.queue.shift()
  }

  start() {
    for (let i = 0; i < this.size; i++) {
      this.dequeue()()
    }
  }
}

export default Queue
